import axios from 'axios'
import { API_URL } from '@/services/api'
import { getAuthToken } from '@/services/sessionProps'
import { getAccountService } from '@/services/accountService'
import { getAuthService } from '@/services/authService'

const PaymentService = {

  async createSinglePayment (key) {
    const user = await getAccountService().getAccount(
      await getAuthService().getLoggedInKey(), false)

    try {
      const data = await axios.post(`${API_URL}/api/single_payment_payus`, {
          product: key,
          user: user.key
        },
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
          }
        })

      return data.data.id

    } catch (e) {
      return null
    }
  },

  async getPaymentUrl (key, id) {
    const user = await getAccountService().getAccount(
      await getAuthService().getLoggedInKey(), false)

    try {
      const data = await axios.put(`${API_URL}/api/single_payment_payus/${id}/register`, {
          product: key,
          user: user.key
        },
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
          }
        })

      return data.data.returnUrl

    } catch (e) {
      return null
    }
  },

  async createPendingOrdinaryTransferPayment (id) {
    const userAccount = await getAccountService().getAccount(
      await getAuthService().getLoggedInKey(), false)
    try {
      return await axios.post(`${API_URL}/api/ordinary_transfer_payments`, {
          user: userAccount.key,
          status: 'PENDING',
          product: id
        },
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
          }
        })

    } catch (e) {
      return null
    }
  },

  async checkRecurringSubscriptionPlans () {
    const user = await getAccountService().getAccount(
      await getAuthService().getLoggedInKey(), false)

    try {
      const data = await axios.get(`${API_URL}${user.key}/recurring_subscription_plans`,
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
          }
        })

      return data.data['hydra:member']

    } catch (e) {
      return null
    }
  },

  async createRecurringSubscriptionPlans () {
    const user = await getAccountService().getAccount(
      await getAuthService().getLoggedInKey(), false)

    try {
      const data = await axios.post(`${API_URL}/api/recurring_subscription_plans`, {
          owner: user.key,
          product: '/api/products/3'
        },
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
          }
        })

      return data

    } catch (e) {
      return null
    }
  },

  async checkPayuCard () {
    const user = await getAccountService().getAccount(
      await getAuthService().getLoggedInKey(), false)

    try {
      const data = await axios.get(`${API_URL}${user.key}/payu_card`,
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
          }
        })

      return data

    } catch (e) {
      return null
    }
  },

  async checkPayuCardForUser (id) {

    try {
      const result = await axios.get(`${API_URL}${id}/payu_card`,
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
          }
        })

      return result.data

    } catch (e) {
      return null
    }
  },

  async deletePayuCard (id) {

    try {
      const data = await axios.delete(`${API_URL}${id}`,
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
          }
        })

      return data

    } catch (e) {
      return null
    }
  },

  async createPayuCard (key) {
    const user = await getAccountService().getAccount(
      await getAuthService().getLoggedInKey(), false)

    try {
      const data = await axios.post(`${API_URL}/api/payu_cards`, {
          user: user.key,
          firstPaymentToken: key
        },
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
          }
        })

      return data

    } catch (e) {
      return null
    }
  },

  async createFirstTransaction () {
    const user = await getAccountService().getAccount(
      await getAuthService().getLoggedInKey(), false)

    try {
      const data = await axios.post(`${API_URL}/api/recurring_payu_payments`, {
          user: user.key,
          product: '/api/products/1'
        },
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
          }
        })

      return data.data.id

    } catch (e) {
      return null
    }
  },

  async getRecurringPayuPaymentUrl (id) {

    try {
      const data = await axios.put(`${API_URL}/api/recurring_payu_payments/${id}/register`,
        {},
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
          }
        })

      return data.data.returnUrl

    } catch (e) {
      return null
    }
  },

  async createInstalmentPayment (key) {
    const userAccount = await getAccountService().getAccount(
      await getAuthService().getLoggedInKey(), false)
    try {
      const data = await axios.post(`${API_URL}/api/santander_credits`, {
          product: key,
          user: userAccount.key
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getAuthToken()}`,
          }
        })
      return data.data.id

    } catch (e) {
      return null
    }
  },

  async getInstalmentPaymentUrl (id, key) {
    const userAccount = await getAccountService().getAccount(
      await getAuthService().getLoggedInKey(), false)
    try {
      const data = await axios.put(`${API_URL}/api/santander_credits/${id}/register`, {
          product: key,
          user: userAccount.key
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getAuthToken()}`,
          }
        })
      return data.data.returnURL

    } catch (e) {
      return null
    }
  },

  async checkPaymentStatus (paymentId) {
    try {
      const data = await axios.get(`${API_URL}/api/recurring_payu_payments/status?internalOrderId=${paymentId}`,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        }
      })

      return data.data['hydra:member']

    } catch (e) {
      return null
    }
  },
}

/* eslint-disable import/prefer-default-export */
export function getPaymentService () {
  return PaymentService
}
